import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/crm'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'crm_settings_wrapper',
          meta: {
            permissions: ['administrator', 'agent', 'custom_role'],
          },
          redirect: to => {
            return { name: 'crm_settings_index', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'crm_settings_index',
          meta: {
            permissions: ['administrator', 'agent', 'custom_role'],
          },
          component: Index,
        },
      ],
    },
  ],
};
